import ManageDealUpdateResponseHelper from "@/models/managedealupdate-response";
export default class ManageResponseFactory {

  static createFromJsonArray(jsonArray) {
    if (Array.isArray(jsonArray)) {
      const jsonData = [];
      jsonArray.forEach((item) => {
        jsonData.push(ManageDealUpdateResponseHelper.createFromJson(item));
      });
      console.log(jsonData, "JsonData");
      return jsonData;
    } else if (typeof jsonArray === "object") {
      const jsonData = ManageDealUpdateResponseHelper.createFromJson(jsonArray);
      return jsonData;
    } else {
      console.error("jsonArray is not an array or an object");
      return [];
    }
  }
}
